import HttpClientToken from '../../services/HttpClientToken';

import { defaultTipoPrestacion, TipoPrestacionProps } from '../../interfaces/catalogos/TipoPrestacionInterface';

export const TipoPrestaciones = () => {

    return new Promise<TipoPrestacionProps[]>( (resolve) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/TipoPrestacion/', token)
            .then( ({ data } : { data : TipoPrestacionProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const ObtenerTipoPrestaciones = () => {

    return new Promise<TipoPrestacionProps[]>( (resolve) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.get('/Api/TipoPrestacion/ObtenerTipoPrestaciones', token)
            .then( ({ data } : { data : TipoPrestacionProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const ActualizarTipoPrestacion = ( params: TipoPrestacionProps ) => {

    return new Promise<TipoPrestacionProps>( (resolve) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/TipoPrestacion/Actualizar', params, token)
            .then( ({ data } : { data : TipoPrestacionProps } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( { ...defaultTipoPrestacion } );
            });

        }

    });

}

export const AgregarTipoPrestacion = ( params: TipoPrestacionProps ) => {

    return new Promise<TipoPrestacionProps>( (resolve) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/TipoPrestacion/Agregar', params, token)
            .then( ({ data } : { data : TipoPrestacionProps } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( { ...defaultTipoPrestacion } );
            });

        }

    });

}
